var DEFAULT_INTEGRATION = {
  engine: "html5",
  orientation: "portrait",
  integrationMode: "legacy-compat",
  sdkProfile: "none",
  entryFile: "index.html",
  adSupport: {
    interstitial: true,
    rewarded: true
  },
  features: {
    fullscreen: true,
    save: true
  },
  health: {
    status: "verified"
  }
}

var GAME_INTEGRATIONS = {
  "hell-sheep": { engine: "cocos", orientation: "portrait" },
  "pet-island": { engine: "laya", orientation: "landscape" },
  "SaveTheDoge": { engine: "cocos", orientation: "portrait" },
  "SubwaySurfersIceland": { engine: "html5", orientation: "landscape", sdkProfile: "poki" },
  "aquapark-shark": { engine: "construct2", orientation: "portrait" },
  "moon_pioneer_online": { engine: "laya", orientation: "landscape" },
  "beat-rhythm-run": { engine: "laya", orientation: "landscape" },
  "bloody battle": { engine: "cocos", orientation: "portrait" },
  "human-evolution": { engine: "laya", orientation: "landscape" },
  "RadishGirl": { engine: "cocos", orientation: "portrait" },
  "TeethRunner": { engine: "playcanvas", orientation: "portrait" },
  "atom-war": { engine: "cocos", orientation: "portrait" },
  "robot-hunter": { engine: "cocos", orientation: "portrait" },
  "power-light": { engine: "construct3", orientation: "portrait", sdkProfile: "sdk-options" },
  "moto": { engine: "html5", orientation: "landscape", sdkProfile: "gdsdk" },
  "mergeEmpires": { engine: "cocos", orientation: "landscape", integrationMode: "native" },
  "tropical-merge": { engine: "cocos", orientation: "landscape" },
  "ttt": { engine: "html5", orientation: "landscape", sdkProfile: "poki" },
  "That-s-My-Seat": { engine: "construct3", orientation: "portrait", sdkProfile: "azerion" },
  "tanks-a-lot": { engine: "construct2", orientation: "portrait" },
  "food-empire-inc": { engine: "html5", orientation: "landscape", sdkProfile: "parent-gameapi" },
  "hunter-assassin2": { engine: "construct2", orientation: "portrait" },
  "fieldrunners-td": { engine: "laya", orientation: "landscape" },
  "scarabaeus": {
    engine: "html5",
    orientation: "landscape",
    adSupport: {
      interstitial: false,
      rewarded: false
    }
  },
  "BridgeRunRace": { engine: "laya", orientation: "landscape" },
  "thread-sort": {
    engine: "construct3",
    orientation: "portrait",
    sdkProfile: "none",
    integrationMode: "native"
  }
}

function mergeDeep(base, extra) {
  var result = Object.assign({}, base)

  Object.keys(extra || {}).forEach(function(key) {
    var value = extra[key]
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      result[key] &&
      typeof result[key] === "object" &&
      !Array.isArray(result[key])
    ) {
      result[key] = mergeDeep(result[key], value)
      return
    }

    result[key] = value
  })

  return result
}

function getGameIntegration(id) {
  return mergeDeep(DEFAULT_INTEGRATION, GAME_INTEGRATIONS[id] || {})
}

export {
  DEFAULT_INTEGRATION,
  GAME_INTEGRATIONS,
  getGameIntegration
}



// WEBPACK FOOTER //
// ./src/common/config/game-integrations.js